import React, { useState, useEffect } from 'react';
import { Form,  Select, Typography } from 'antd';
import { CloseOutlined, EditOutlined } from '@ant-design/icons';
import { fetchMCPServerCategories } from '../../MCPServerApis';

const { Text } = Typography;

const EditCategory = ({ category }) => {
    const formName = ['basicDetails', 'category_id'];
    const [selCategory, setSelCategory] = useState(category);
    const [editing, setEditing] = useState(false);
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (options.length === 0) return;
        setSelCategory(category);
    }, [options]);

    useEffect(() => {
        if (!editing) return;
        if (options.length > 0) return;
        setLoading(true);
        fetchMCPServerCategories()
            .then((categories) => {
                setOptions(categories.map((cat) => ({ value: cat.category_id, label: cat.category_name })));
                setLoading(false);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [editing]);

    const onEdit = async (categoryValue) => {
        const category = options.find((cat) => cat.value === categoryValue);
        setSelCategory(category ? category.label : null);
    };

    if (loading) {
        return <Text>Loading...</Text>;
    }

    return (
        <>
            <div className='ns-flex gap-2 items-baseline'>
                <Form.Item name={formName}>
                    {editing ? (
                        <Select style={{ width: 250 }} defaultValue={category} options={options} onSelect={onEdit} />
                    ) : (
                        <Text>{selCategory}</Text>
                    )}
                </Form.Item>
                {editing ? (
                    <CloseOutlined onClick={() => setEditing(false)} />
                ) : (
                    <EditOutlined style={{ color: '#1890ff' }} onClick={() => setEditing(true)} />
                )}
            </div>
        </>
    );
};

export default EditCategory;
